<template>
    <div>
        <component :blok="story.content" :is="story.content.component"></component>
    </div>
</template>
    
<script>
    import StoryblokClient from 'storyblok-js-client'

    let token;
    if (process.env.NODE_ENV === 'development')
        token = 'FSjhvUmShzm9dnZTy6D6lQtt';
    else
        token = 'msdQIPHSBm3k0nV59Dp6Igtt';

    let storyapi = new StoryblokClient({
        accessToken: token
    });

    export default {
        name: 'PageDynamic',
        props: ['pageId'],
        data() {
            return {
                id: this.pageId,
                story: {
                    content: {
                        body: []
                    }
                }
            };
        },
        created() {
            window.storyblok.init({
                accessToken: token
            });

            window.storyblok.on('change', () => {
                this.getStory(this.id, 'draft')
            });

            window.storyblok.pingEditor(() => {
                if (window.storyblok.isInEditor() ||
                    process.env.NODE_ENV === 'development') {
                    this.getStory(this.id, 'draft')
                } else {
                    this.getStory(this.id, 'published')
                }
            });
        },
        methods: {
            getStory(slug, version) {
                storyapi.get('cdn/stories/' + slug, {
                    version: version
                })
                .then((response) => {
                    this.story = response.data.story
                })
                .catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>